<form method="post">
  <h4 class="text-center">ブラウザ登録</h4>
  <div class="illustration">
    <i class="fa fa-desktop login-icon"></i>
  </div>
  <div class="description">
    お使いのブラウザに任意の名前をつけて登録してください。<br>
    最大２個まで登録できます。<br>
    登録済みブラウザを削除する場合は、&times;をクリックしてください。<br>
    <p class="warning">削除後、72時間経過するまで同じブラウザを再登録することはできません。</p>
  </div>

  <ng-container *ngFor="let browser of browsers; index as i">
    <div class="form-group d-flex justify-content-between align-items-center">
      <input class="form-control col-10" type="text" value={{browser.name}} readonly>
      <button class="btn btn-danger col-1" type="submit" (click)="openModal($event, browser, confirmModal)">&times;</button>
    </div>
  </ng-container>

  <ng-container *ngIf="browsers.length < 2">
    <div class="form-group">
      <input class="form-control" type="text" name="newBrowserName" placeholder="登録するブラウザ名" [(ngModel)]="newBrowserName">
    </div>
    <div class="form-group">
      <button class="btn btn-primary-dark btn-block" type="submit" (click)="registerBrowser()">保存する</button>
    </div>
  </ng-container>

  <a href="#" class="forgot text-right" (click)="cancel($event)">キャンセル</a>
</form>

<ng-template #confirmModal let-modal>
  <div class="modal-section">
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span class="close-button" aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <p>
        ブラウザ名: {{ selectedBrowser.name }} <br>
        上記のブラウザを削除します。<br>
        削除後、72時間経過するまで同じブラウザを再登録することはできません。削除しますか？
      </p>
      <div class="d-flex justify-content-between">
        <button type="button" class="btn btn-dark" (click)="modal.dismiss()" ngbAutofocus>キャンセル</button>
        <button type="button" class="btn btn-primary-dark" (click)="deleteBrowser()">はい</button>
      </div>
    </div>
  </div>
</ng-template>
